// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2DCMj","footer":"ModalCreateQualiphyProcedure_footer__lm92G","additionData":"ModalCreateQualiphyProcedure_additionData__2E3qn"};